import axiosInstance from '../../utils/AxiosInstance'
import moment from 'moment'

import { randomNumber } from '../../utils/helpers'
import { SEARCH, THREAD_ID, REPLIES } from './types'

import { preloader } from '../Preloader/actions'
import { getThreads } from '../Discussion/actions'

const setThreadId = (threadId) => ({ type: THREAD_ID, threadId })

export const setReplies = (list) => ({ type: REPLIES, list })
export const searchReplies = (value) => ({ type: SEARCH, value })
export const searchRepliesReset = () => ({ type: SEARCH, value: '' })

const createPostObject = ({ first_name, last_name, job_title }) => ({
  edit: true,
  id: randomNumber(),
  content: {
    user: {
      first_name,
      last_name,
      job_title,
    },
    data: null,
    text: '',
    children: [],
  },
})

export const getReplies = (id) => {
  return (dispatch, getState) => {
    dispatch(setThreadId(id))

    axiosInstance.get(`/topics/${id}/comments`).then((data) => {
      dispatch(setReplies(data))
      dispatch(preloader())
    })

    // api.get(`/reply/${id}`).then((response) => {
    //     dispatch(setReplies(response.data))
    //     dispatch(preloader())
    // })
  }
}

export const addComment = () => {
  return (dispatch, getState) => {
    const { list } = getState().comments
    const post = createPostObject(getState().users)

    const updatedReplies = [...[post], ...list]

    dispatch(setReplies(updatedReplies))
  }
}

export const saveComment = () => {
  return (dispatch, getState) => {
    const { index, list, threadId } = getState().comments
    const { edit, ...post } = list[index]

    if (!post.content.text || !post.content.text.trim()) {
      alert('You can not save an empty comment')
      return
    }

    axiosInstance
      .post(`/topics/${threadId}/comments`, {
        content: JSON.stringify({
          ...post.content,
          time: moment().format('MM-DD-YYYY -- h:mm a'),
        }),
      })
      .then((data) => {
        const updatedReplies = [data, ...list.slice(index + 1)]

        dispatch(setReplies(updatedReplies))
        dispatch(getThreads())
      })

    // api.post('/reply/create', {
    //     threadId: threadId,
    //     content: JSON.stringify({
    //         ...post.content,
    //         time: moment().format('MM-DD-YYYY -- h:mm a')
    //     })
    // }).then((response) => {
    //     const updatedReplies = [
    //         ...[ response.data ],
    //         ...list.slice(index + 1)
    //     ]

    //     dispatch(setReplies(updatedReplies))
    // })
  }
}

export const deleteComment = (commentId) => {
  return (dispatch, getState) => {
    const { list, threadId } = getState().comments

    const index = list.findIndex((item) => item.id === commentId)

    const { id, edit } = list[index]

    let language = {}
    // eslint-disable-next-line no-unused-expressions
    getState().language.language
      ? (language = getState().language.language.data)
      : null
    if (
      // edit ||
      // eslint-disable-next-line no-restricted-globals
      confirm(language.alerts ? language.alerts.delete_post_confirm : null)
    ) {
      const updatedReplies = [...list.slice(0, index), ...list.slice(index + 1)]

      dispatch(setReplies(updatedReplies))

      if (!edit) {
        axiosInstance.delete(`/topics/${threadId}/comments/${id}`)
      }
    }
  }
}

export const onChange = (property, value) => {
  return (dispatch, getState) => {
    const { index, list } = getState().comments

    const updatedReplies = [
      ...list.slice(0, index),
      {
        ...list[index],
        content: { ...list[index].content, [property]: value },
      },
      ...list.slice(index + 1),
    ]

    dispatch(setReplies(updatedReplies))
  }
}

export const addReply = (commentId, parentId, id) => {
  return (dispatch, getState) => {
    const { list } = getState().comments
    const post = {
      ...createPostObject(getState().users),
      ...(parentId ? { commentId, parentId } : { commentId }),
    }
    const index = list.findIndex((item) => item.id === commentId)

    const updatedReplies = [
      ...list.slice(0, index),
      {
        ...list[index],
        content: {
          ...list[index].content,
          children: [...list[index].content.children, ...[post]],
        },
      },
      ...list.slice(index + 1),
    ]

    dispatch(setReplies(updatedReplies))
  }
}

export const deleteReply = (postId, id) => {
  return (dispatch, getState) => {
    const { list, threadId } = getState().comments
    const parentIndex = list?.findIndex((item) => item.id === postId)
    const children = list[parentIndex].content?.children
    const index = children?.findIndex((item) => item.id === id)
    const edit = children[index].edit
    let language = {}
    // eslint-disable-next-line no-unused-expressions
    getState().language.language
      ? (language = getState().language.language.data)
      : null

    const updatedReplies = [
      ...list.slice(0, parentIndex),
      {
        ...list[parentIndex],
        content: {
          ...list[parentIndex].content,
          children: [...children.slice(0, index), ...children.slice(index + 1)],
        },
      },
      ...list.slice(parentIndex + 1),
    ]

    if (
      edit ||
      // eslint-disable-next-line no-restricted-globals
      confirm(language.alerts ? language.alerts.delete_post_confirm : null)
    ) {
      dispatch(setReplies(updatedReplies))

      const { list } = getState().comments
      const { content } = list[parentIndex]

      if (!edit) {
        axiosInstance.patch(`/topics/${threadId}/comments/${postId}`, {
          content: JSON.stringify(content),
        })

        // api.post('/reply/update', {
        //     id: postId,
        //     content: JSON.stringify(content)
        // })
      }
    }
  }
}

export const onChangeReply = (commentId, property, value) => {
  return (dispatch, getState) => {
    const { list } = getState().comments
    const commentIndex = list.findIndex((item) => item.id === commentId)
    const children = list[commentIndex].content.children
    const index = children?.findIndex((item) => item.edit)

    let editState = property === 'edit' ? { edit: false } : {}
    let contentState = property === 'edit' ? {} : { [property]: value }

    const updatedReplies = [
      ...list.slice(0, commentIndex),
      {
        ...list[commentIndex],
        content: {
          ...list[commentIndex]?.content,
          children: [
            ...children.slice(0, index),
            {
              ...children[index],
              ...editState,
              content: { ...children[index]?.content, ...contentState },
            },
            ...children.slice(index + 1),
          ],
        },
      },
      ...list.slice(commentIndex + 1),
    ]

    dispatch(setReplies(updatedReplies))
  }
}

export const saveReply = (postId) => {
  return (dispatch, getState) => {
    dispatch(onChangeReply(postId, 'edit', false))

    const { list, threadId } = getState().comments
    const parentIndex = list.findIndex((item) => item.id === postId)
    const { content } = list[parentIndex]

    axiosInstance.patch(`/topics/${threadId}/comments/${postId}`, {
      content: JSON.stringify(content),
    })

    // api.post('/reply/update', {
    //     id: postId,
    //     content: JSON.stringify(content)
    // })
  }
}
